import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';

export interface ModalProps extends ReactModal.Props {}

// TODO: Implment a modal we can reuse in other places
export const Modal: React.FC<ModalProps & ReactNode> = (props) => {
  return <ReactModal {...props} />;
};
